var map = {
	"./de-DE.json": 5857,
	"./en-GB.json": 9398,
	"./en-KR.json": 8132,
	"./en-UK.json": 7199,
	"./fr-FR.json": 2631,
	"./it-IT.json": 2277,
	"./nl-NL.json": 4637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5000;